<template>
  <div class="pos-pay">
    <absolute-loader :showLoader="paymentLoading" mode="relative" />
    <div class="live-messages">
      <transition
      enter-active-class="animate__animated animate__fadeInUp animate__faster"
      leave-active-class="animate__animated animate__fadeOutUp animate__faster">
        <p class="messages" :key="liveMessage">{{liveMessage}}</p>
      </transition>
    </div>
  </div>
</template>

<script>
import AbsoluteLoader from 'theme/components/AbsoluteLoader/AbsoluteLoader'

export default {
  name: 'PosPay',
  computed: {
    paymentLoading () {
      return this.$store.getters['pos/paymentLoading']
    },
    liveMessage () {
      // one shot message
      return this.$store.getters['pos/paymentMessage']
    }
  },
  components: {
    AbsoluteLoader
  }
}
</script>
